AOS.init();

jQuery(document).ready(function ($) {

    jQuery("li.menu-item-has-children a").append("<span class='arrow'><i class='fas fa-chevron-down'></i><i class='fas fa-chevron-up'></i></span>");

    jQuery(".wysiwyg iframe").wrap("<div class='new' data-aos='fade-down'  data-aos-duration='600'></div>");
    jQuery(".wysiwyg figure").wrap("<div class='new' data-aos='fade-down'  data-aos-duration='600'></div>");

    jQuery('#nav-icon3').click(function () {
        if (jQuery("body").hasClass("openmenu")) {
            jQuery(".header__navigation__list").hide();
            jQuery(".header__navigation__nav").slideUp();
            jQuery(".header__helper").hide();
            setTimeout(function () {
                jQuery(".header__navigation__list").show();
            }, 200);
        } else {
            jQuery(".header__navigation__nav").slideDown();
            if (jQuery("body").hasClass("sticky")) {
                jQuery(".header__helper").delay(400).fadeIn(700);
            }
        }
        jQuery(this).toggleClass('open');
        jQuery("body").toggleClass('openmenu');

        if (jQuery(".header").height() >= 134) {
            tempheightTop = jQuery(".header").height() + jQuery("#wpadminbar").height();
            //  tempheightTop = "90px";
        } else {
            tempheightTop = "120px";
        }
        jQuery(".header__navigation").css("top", tempheightTop) + jQuery("#wpadminbar").height();
    });



    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 70) {
            jQuery('.scrolltop:hidden').stop(true, true).fadeIn();
        } else {
            jQuery('.scrolltop').stop(true, true).fadeOut();
        }
    });

    jQuery(".scrolltop").click(function () {
        $("html,body").animate({scrollTop: $(".top").offset().top}, "1000");
        return false
    })

    window.onscroll = function () {
        scrolled();
    };
    var navbar = document.querySelector(".header__content__main");
    var body = document.body;
    var sticky = navbar.offsetTop;
    if (window.pageYOffset >= sticky) {
        body.classList.add("sticky")
    }

    function scrolled() {
        if (window.pageYOffset >= sticky + 100) {
            body.classList.add("sticky")
        } else {
            body.classList.remove("sticky");
        }
    }

});
